// src/pages/connect/Xentral.js
import React, { useState } from "react";
import { Card, Button, Alert, Modal, Table, Spinner } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRocket, faPlug } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const Xentral = () => {
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const API_BASE = `https://api-dashboard.nordmann-inkasso.de
/api/xentral`; // backend endpoint

  const handleConnect = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${API_BASE}/connect`, {
        userId: "12345", // replace with logged-in user ID
      });
      if (res.data.success) {
        setConnected(true);
      }
    } catch (err) {
      console.error("Error connecting to Xentral:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnect = async () => {
    try {
      setLoading(true);
      const res = await axios.post(`${API_BASE}/disconnect`, {
        userId: "12345",
      });
      if (res.data.success) {
        setConnected(false);
        setInvoices([]);
      }
    } catch (err) {
      console.error("Error disconnecting from Xentral:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewInvoices = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/invoices`, {
        params: { userId: "12345" },
      });
      if (res.data.success) {
        setInvoices(res.data.invoices);
        setShowModal(true);
      }
    } catch (err) {
      console.error("Error fetching invoices from Xentral:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h3 className="mb-4">
        <FontAwesomeIcon icon={faPlug} className="me-2" />
        Connect Xentral
      </h3>

      <Card className="shadow-sm">
        <Card.Body>
          <FontAwesomeIcon icon={faRocket} size="2x" className="mb-3 text-danger" />
          <Card.Title>Xentral</Card.Title>
          <Card.Text>
            Connect your Xentral ERP system to manage your invoices and bookkeeping centrally.
          </Card.Text>

          {connected ? (
            <>
              <Alert variant="success" className="mt-3">
                ✅ Connected successfully!
              </Alert>
              <Button
                variant="danger"
                className="mt-2 me-2"
                onClick={handleDisconnect}
                disabled={loading}
              >
                {loading ? <Spinner animation="border" size="sm" /> : "Disconnect"}
              </Button>
              <Button
                variant="secondary"
                className="mt-2"
                onClick={handleViewInvoices}
                disabled={loading}
              >
                {loading ? <Spinner animation="border" size="sm" /> : "View Invoices"}
              </Button>
            </>
          ) : (
            <Button
              variant="danger"
              className="mt-2"
              onClick={handleConnect}
              disabled={loading}
            >
              {loading ? <Spinner animation="border" size="sm" /> : "Connect to Xentral"}
            </Button>
          )}
        </Card.Body>
      </Card>

      {/* Modal to display invoices */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Xentral - Overdue Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {invoices.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Invoice ID</th>
                  <th>Customer</th>
                  <th>Amount</th>
                  <th>Due Date</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv) => (
                  <tr key={inv.invoiceId}>
                    <td>{inv.invoiceId}</td>
                    <td>{inv.customerName}</td>
                    <td>{inv.amount}</td>
                    <td>{new Date(inv.dueDate).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p>No overdue invoices found.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Xentral;
